var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComputer = function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#51C394",
    rx: 16,
    transform: "matrix(-1 0 0 1 80 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20 18h40c2.205 0 4 1.78 4 3.968v27.779c0 2.189-1.795 3.968-4 3.968H45.997c.043 1.586.35 4.122 1.491 5.311.418.438.899.642 1.512.642.553 0 1 .444 1 .992a.996.996 0 0 1-1 .992H31c-.553 0-1-.444-1-.992a.996.996 0 0 1 1-.992c.613 0 1.094-.204 1.514-.642 1.144-1.196 1.448-3.728 1.49-5.31H20c-2.205 0-4-1.78-4-3.969V21.968C16 19.78 17.795 18 20 18m0 3.968v25.25h39.826l-.002-25.25zm18.957 4.38h-14.61v16.696h14.61zm2.087 0h14.608v6.26H41.044zm14.608 8.348H41.044v8.348h14.608z",
    clipRule: "evenodd"
  })));
};
export default SvgComputer;